import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Container from 'components/Container'

export default function UnauthView({ children, className }: props) {
  return (
    <div className={classNames('UnauthView', className)}>
      <Container>
        {children}
      </Container>
    </div>
  )
}

UnauthView.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/UnauthView/UnauthView.js